import { PromptTemplate } from '../types';

const PROJECT_TYPES = [
  'Content Creation', 'Strategic Planning', 'Project Management', 
  'Business Documentation', 'Creative Writing', 'Marketing Campaign',
  'Product Development', 'Research & Analysis', 'Personal Development',
  'Educational Content', 'Other'
];

export const projectPrompt: PromptTemplate = {
  type: 'project',
  template: `First, provide a helpful conversational response that:
1. Acknowledges the user's project creation need naturally
2. Explains why organizing this into a project structure would be beneficial
3. Provides context about project management benefits, goal alignment, or strategic value

Then, if you believe the user wants a project creation recommendation, include this structured format below your conversational response:

---RECOMMENDATION---
PROJECT TITLE: [clear, actionable project title]
PROJECT DESCRIPTION: [detailed description of what success looks like for this project, including key milestones and outcomes]
PROJECT TYPE: [Select ONE of these project types: ${PROJECT_TYPES.join(', ')}]
---END RECOMMENDATION---

EXISTING PROJECTS CONTEXT:
{AVAILABLE_PROJECTS_LIST}

Provide both the conversational response AND the structured recommendation in a single response. The conversational part maintains natural dialogue flow while the structured part enables action card creation.

OR if you need extra context to provide the perfect recommendation, continue chatting conversationally without the structured format.

Focus on creating projects that complement existing work and avoid duplication. Consider what would make this project unique and valuable.`,
  validation: {
    requiredFields: ['PROJECT TITLE', 'PROJECT DESCRIPTION', 'PROJECT TYPE'],
    stopKeywords: ['---RECOMMENDATION---', '---END RECOMMENDATION---'],
    maxRecommendations: 1,
    allowedValues: {
      'PROJECT TYPE': PROJECT_TYPES
    }
  }
}; 